import {call, put} from "redux-saga/effects";
import {
    annulationTransactionApi,
    excelExportApi,
    getConsultationTransactionsListApi,
} from "../../../../common/apis/transactionApi";
import * as actions from "../state/consultationTransactionsActions";

export function* getConsultationTransactionsListSaga({ payload }) {
  try {
    const response = yield call(getConsultationTransactionsListApi, payload);
    yield put(
      actions.getConsultationTransactionsListSuccessAction(response.data.body)
    );
  } catch (error) {
    yield put(actions.getConsultationTransactionsListFailAction(error));
  }
}

export function* annulationTransactionSaga({ payload }) {
  try {
    console.log("annulationTransactionSaga called with payload:", payload);
    const response = yield call(annulationTransactionApi, payload);
    console.log("annulationTransactionApi response:", response);
    yield put(actions.annulationTransactionSuccessAction(response.data.body));
  } catch (error) {
    console.error("annulationTransactionSaga error:", error);
    yield put(actions.annulationTransactionFailAction(error));
  }
}

export function* excelExportSaga({ payload }) {
  try {
    const response = yield call(excelExportApi, payload);
    yield put(actions.printSuccess(response.data));
  } catch (error) {
    yield put(actions.printFail(error));
  }
}